import axios from "axios";
import PayrollBatchEmployeeService from "./PayrollBatchEmployeeService";
import { getLoggedInServiceNo } from "../utils/masterDataUtils"
import api from "../services/api";

const GetPayRollPeriodList = async () => {
    return axios
        .get(`PayRoll/GetPayRollPeriod`)
        .then((response) => response);
}

const AddPayRollPeriod = async (payload) => {
    const {
        periodCode,
        periodName,
        year,
        month,
        payrollStartDate,
        payrollEndDate,
        payFrequency,
        attendanceStartDate,
        attendanceEndDate,
        otStartDate,
        otEndDate,
        paymentDate,
        status,
        isLocked,
        glPosted,
        bankTransferGenerated,
        createdBy,
        isActive,
        remarks,
    } = payload;

    return axios
        .post(`PayRoll/AddPayRollPeriod`, null, {
            params: {
                p_periodCode: periodCode,
                p_periodName: periodName,
                p_year: year,
                p_month: month,
                p_payrollStartDate: payrollStartDate,
                p_payrollEndDate: payrollEndDate,
                p_pay_fRequency: payFrequency,
                p_attendanceStartDate: attendanceStartDate,
                p_attendanceEndDate: attendanceEndDate,
                p_otStartDate: otStartDate,
                p_otEndDate: otEndDate,
                p_paymentDate: paymentDate,
                p_status: status,
                p_isLocked: isLocked,
                p_glPosted: glPosted,
                p_bankTransferGenerated: bankTransferGenerated,
                p_createdBy: createdBy,
                p_isActive: isActive,
                p_remarks: remarks,
            },
        })
        .then((response) => response);
};

const UpdatePayRollPeriod = async (payload) => {
    const params = {
        p_payrollPeriodId: payload.payrollPeriodId,

        ...(payload.periodCode !== undefined &&
            payload.periodCode !== null && {
            p_periodCode: payload.periodCode,
        }),

        ...(payload.periodName !== undefined &&
            payload.periodName !== null && {
            p_periodName: payload.periodName,
        }),

        ...(payload.year !== undefined &&
            payload.year !== null && {
            p_year: payload.year,
        }),

        ...(payload.month !== undefined &&
            payload.month !== null && {
            p_month: payload.month,
        }),

        ...(payload.payrollStartDate !== undefined &&
            payload.payrollStartDate !== null && {
            p_payrollStartDate: payload.payrollStartDate,
        }),

        ...(payload.payrollEndDate !== undefined &&
            payload.payrollEndDate !== null && {
            p_payrollEndDate: payload.payrollEndDate,
        }),

        ...(payload.attendanceStartDate !== undefined &&
            payload.attendanceStartDate !== null && {
            p_attendanceStartDate: payload.attendanceStartDate,
        }),

        ...(payload.attendanceEndDate !== undefined &&
            payload.attendanceEndDate !== null && {
            p_attendanceEndDate: payload.attendanceEndDate,
        }),

        ...(payload.otStartDate !== undefined &&
            payload.otStartDate !== null && {
            p_otStartDate: payload.otStartDate,
        }),

        ...(payload.otEndDate !== undefined &&
            payload.otEndDate !== null && {
            p_otEndDate: payload.otEndDate,
        }),

        ...(payload.paymentDate !== undefined &&
            payload.paymentDate !== null && {
            p_paymentDate: payload.paymentDate,
        }),

        ...(payload.payFrequency !== undefined &&
            payload.payFrequency !== null && {
            p_pay_fRequency: payload.payFrequency,
        }),

        ...(payload.status !== undefined &&
            payload.status !== null && {
            p_status: payload.status,
        }),

        ...(payload.isLocked !== undefined &&
            payload.isLocked !== null && {
            p_isLocked: payload.isLocked ? 1 : 0,
        }),

        ...(payload.glPosted !== undefined &&
            payload.glPosted !== null && {
            p_glPosted: payload.glPosted ? 1 : 0,
        }),

        ...(payload.bankTransferGenerated !== undefined &&
            payload.bankTransferGenerated !== null && {
            p_bankTransferGenerated: payload.bankTransferGenerated ? 1 : 0,
        }),

        p_updatedBy: getLoggedInServiceNo(),

        ...(payload.isActive !== undefined &&
            payload.isActive !== null && {
            p_isActive: payload.isActive ? 1 : 0,
        }),

        ...(payload.remarks !== undefined &&
            payload.remarks !== null && {
            p_remarks: payload.remarks,
        }),
    };

    return axios.post(
        "PayRoll/UpdatePayRollPeriod",
        null,
        {
            params,
        }
    );
};

const GetPayRollComponentList = async () => {
    return axios
        .get(`PayRollComponent/GetPayRollComponent`)
        .then((response) => response);
}

const AddPayRollComponent = async (payload) => {
    return axios.post(
        "PayRollComponent/AddPayRollComponent",
        null,
        {
            params: {
                p_componentCode: payload.code,
                p_componentName: payload.name,
                p_componentType: payload.type,
                p_paymentType: payload.paymentType,
                p_defaultAmount: payload.defaultAmount,
                p_defaultPercentage: payload.defaultPercentage,
                p_isTaxable: payload.taxable,
                p_calculationMethod: payload.calculationMethod,
                p_createdBy: payload.createdBy ?? 1,
                p_remarks: payload.remarks ?? "",
                //p_earningCategory: payload.earningCategory ?? null,
                P_earning_cat: payload.earningCategory ?? null,
                p_sortOrder: payload.sortOrder,
            },
        }
    )
}

const UpdatePayRollComponent = async (payload) => {
    return axios.post(
        "PayRollComponent/UpdatePayRollComponent",
        null,
        {
            params: {
                p_componentId: payload.id,
                p_componentCode: payload.code,
                p_componentName: payload.name,
                p_componentType: payload.type,
                p_paymentType: payload.paymentType,
                p_defaultAmount: payload.defaultAmount,
                p_defaultPercentage: payload.defaultPercentage,
                p_isTaxable: payload.taxable,
                p_calculationMethod: payload.calculationMethod,
                p_createdBy: payload.createdBy ?? 1,
                p_remarks: payload.remarks ?? "",
                //p_earningCategory: payload.earningCategory ?? null,
                P_earning_cat: payload.earningCategory ?? null,
                p_sortOrder: payload.sortOrder,
            },
        }
    )
}

const GetPayRollBatchList = async () => {
    return axios
        .get(`PayRollBatch/GetPayRollBatch`)
        .then((response) => response);
}

const AddPayRollBatch = async (payload) => {
    const {
        batchId,
        batchNo,
        batchName,
        payrollPeriodId,
        componentId,
        calculationMethod,
        amount,
        percentage,
        effectiveDate,
        description,
        status,
        approvedBy,
        createdBy,
        isActive,
        remarks
    } = payload;

    return axios.post(`PayRollBatch/AddPayRollBatch`, null, {
        params: {
            p_batchId: batchId,
            p_batchNo: batchNo,
            p_batchName: batchName,
            p_payrollPeriodId: payrollPeriodId,
            p_componentId: componentId,
            p_calculationMethod: calculationMethod,
            p_amount: amount,
            p_percentage: percentage,
            p_effectiveDate: effectiveDate,
            p_description: description,
            p_status: status,
            p_approvedBy: approvedBy,
            p_createdBy: createdBy,
            p_isActive: isActive,
            p_remarks: remarks,
        }
    })
}

const UpdatePayRollBatch = async (payload) => {
    const params = {
        p_batchId: payload.batchId,
        ...(payload.batchNo !== undefined && payload.batchNo !== null && {
            p_batchNo: payload.batchNo,
        }),
        ...(payload.batchName !== undefined && payload.batchName !== null && {
            p_batchName: payload.batchName,
        }),
        ...(payload.payrollPeriodId !== undefined && payload.payrollPeriodId !== null && {
            p_payrollPeriodId: payload.payrollPeriodId,
        }),
        ...(payload.componentId !== undefined && payload.componentId !== null && {
            p_componentId: payload.componentId,
        }),
        ...(payload.calculationMethod !== undefined && payload.calculationMethod !== null && {
            p_calculationMethod: payload.calculationMethod,
        }),
        ...(payload.amount !== undefined && payload.amount !== null && {
            p_amount: payload.amount,
        }),
        ...(payload.percentage !== undefined && payload.percentage !== null && {
            p_percentage: payload.percentage,
        }),
        ...(payload.effectiveDate !== undefined && payload.effectiveDate !== null && {
            p_effectiveDate: payload.effectiveDate,
        }),
        ...(payload.description !== undefined && payload.description !== null && {
            p_description: payload.description,
        }),
        ...(payload.status !== undefined && payload.status !== null && {
            p_status: payload.status,
        }),
        ...(payload.approvedBy !== undefined && payload.approvedBy !== null && {
            p_approvedBy: payload.approvedBy,
        }),
        ...(payload.postedBy !== undefined && payload.postedBy !== null && {
            p_postedBy: payload.postedBy,
        }),
        ...(payload.updatedBy !== undefined && payload.updatedBy !== null && {
            p_updatedBy: payload.updatedBy,
        }),
        ...(payload.isActive !== undefined && payload.isActive !== null && {
            p_isActive: payload.isActive ? 1 : 0,
        }),
        ...(payload.remarks !== undefined && payload.remarks !== null && {
            p_remarks: payload.remarks,
        }),
    };

    return axios.post(
        "PayRollBatch/UpdatePayRollBatch",
        null,
        {
            params,
        }
    );
};

const GetPayRollHeaderList = async () => {
    return axios
        .get(`PayRollHeader/GetPayRollHeader`)
        .then((response) => response);
}

const getPayrollHeadersByPeriod = async (payrollPeriodId) => {
    return axios.get("PayrollCal/GetPayrollHeadersByPeriod", {
        params: {
            P_PAYROLL_PERIOD_ID: payrollPeriodId,
        }
    })
}

const GetEmployeeSalaryList = async () => {
    return axios
        .get("EmployeeSalary/GetAllEmpSalary")
        .then((response) => response);
}

const AddEmployeeSalary = async (payload) => {
    return axios.post(
        "EmployeeSalary/AddEmpSalary",
        null,
        {
            params: {
                p_effectiveDate: payload.effectiveDate,
                p_isActive: payload.isActive ? 1 : 0,
                p_employeeId: payload.employeeId,
                // p_payrollPeriodId: payload.payrollPeriodId,
                p_salaryReference: payload.salaryReference,
                p_endDate: payload.endDate,
                p_grossSalary: payload.grossSalary,
                p_basicSalary: payload.basicSalary,
                p_standardWorkingDays: payload.workingDays,
                // p_standardWorkingHours: payload.workingHours,
                // p_hourlyRate: 0,
                p_dailyRate: payload.dailyRate,
                // p_isCurrent: payload.isCurrent ? 1 : 0,
                p_isCurrent: 1,
                p_approvedBy: getLoggedInServiceNo(),
                p_createdBy: getLoggedInServiceNo(),
                p_payFrequency: payload.payFrequency,
                p_remarks: payload.remarks ?? "",
            },
        }
    );
};

const UpdateEmployeeSalary = async (payload) => {
    return axios.post(
        "EmployeeSalary/UpdateEmpSalary",
        null,
        {
            params: {
                p_employeeSalaryId: payload.employeeSalaryId,

                // Only send the fields that are actually being updated
                // ...(payload.employeeId !== undefined &&{
                //     p_employeeId: payload.employeeId,
                // }),
                // ...(payload.payrollPeriodId !== undefined &&{
                //     p_payrollPeriodId: payload.payrollPeriodId,
                // }),
                ...(payload.salaryReference !== undefined && {
                    p_salaryReference: payload.salaryReference,
                }),
                ...(payload.effectiveDate !== undefined && {
                    p_effectiveDate: payload.effectiveDate,
                }),
                ...(payload.endDate !== undefined && {
                    p_endDate: payload.endDate,
                }),
                ...(payload.payFrequency !== undefined && {
                    p_payFrequency: payload.payFrequency,
                }),
                ...(payload.grossSalary !== undefined && {
                    p_grossSalary: payload.grossSalary,
                }),
                ...(payload.basicSalary !== undefined && {
                    p_basicSalary: payload.basicSalary,
                }),
                ...(payload.workingDays !== undefined && {
                    p_standardWorkingDays: payload.workingDays,
                }),
                // ...(payload.workingHours !== undefined &&{
                //     p_standardWorkingHours: payload.workingHours,
                // }),
                // ...(payload.hourlyRate !== undefined &&{
                //     p_hourlyRate: payload.hourlyRate,
                // }),
                ...(payload.dailyRate !== undefined && {
                    p_dailyRate: payload.dailyRate,
                }),
                ...(payload.isCurrent !== undefined && {
                    p_isCurrent: payload.isCurrent ? 1 : 0,
                }),
                ...(payload.approvedBy !== undefined && {
                    p_approvedBy: payload.approvedBy,
                }),
                ...(payload.updatedBy !== undefined && {
                    p_updatedBy: payload.updatedBy,
                }),
                ...(payload.isActive !== undefined && {
                    p_isActive: payload.isActive ? 1 : 0,
                }),
                ...(payload.remarks !== undefined && {
                    p_remarks: payload.remarks,
                }),
            }
        }
    )
}

const GetEmployeeSalaryComponentList = async () => {
    return axios
        .get("EmployeeSalary/GetAllSalaryComp")
        .then((response) => response);
};

const AddEmployeeSalaryComponent = async (payload) => {
    return axios.post(
        "EmployeeSalary/AddEmpSalaryComp",
        null,
        {
            params: {
                p_employeeSalaryId: payload.employeeSalaryId,
                p_componentId: payload.componentId,
                p_componentAmount: payload.amount,
                p_componentPercentage: payload.percentage,
                p_effectiveDate: payload.effectiveDate,
                p_endDate: payload.endDate,
                p_isActive: payload.isActive ? 1 : 0,
                p_createdBy: payload.createdBy ?? "SYSTEM",
                p_remarks: payload.remarks ?? "",
            }
        }
    )
}

const UpdateEmployeeSalaryComponent = async (payload) => {
    return axios.post(
        "EmployeeSalary/UpdateEmpSalaryComp",
        null,
        {
            params: {
                p_employeeSalaryComponentId: payload.employeeSalaryComponentId,
                p_employeeSalaryId: payload.employeeSalaryId,
                p_componentId: payload.componentId,
                ...(payload.componentAmount !== undefined &&
                    payload.componentAmount !== null && {
                    p_componentAmount: payload.componentAmount,
                }),
                ...(payload.p_componentPercentage !== undefined &&
                    payload.p_componentPercentage !== null && {
                    p_componentPercentage: payload.p_componentPercentage
                }),
                ...(payload.effectiveDate !== undefined &&
                    payload.effectiveDate !== null && {
                    p_effectiveDate: payload.effectiveDate
                }),
                ...(payload.endDate !== undefined &&
                    payload.endDate !== null && {
                    p_endDate: payload.endDate
                }),
                ...(payload.isActive !== undefined &&
                    payload.isActive !== null && {
                    p_isActive: payload.isActive ? 1 : 0
                }),
                p_updatedBy: getLoggedInServiceNo(),
                ...(payload.remarks !== undefined &&
                    payload.remarks !== null && {
                    p_remarks: payload.remarks
                }),
            }
        }
    )
}

const GetLoanList = (isActive = 1) => {
    return axios
        .get(
            "Loan/GetLoans",
            {
                params: {
                    p_loanIsActive: isActive
                }
            }
        )
        .then((response) => response);
};

const AddLoan = (payload) => {
    return axios.post(
        "Loan/AddLoan",
        null,
        {
            params: {
                p_employeeId: payload.employeeId,
                p_loanNo: payload.loanNo,
                p_loanType: payload.loanType,
                p_loanDescription: payload.loanDescription,
                p_loanDate: payload.loanDate,
                p_loanAmount: payload.loanAmount,
                p_interestRate: payload.interestRate,
                p_totalInterest: payload.totalInterest,
                p_totalAmount: payload.totalAmount,
                p_noOfInstallments: payload.noOfInstallments,
                p_installmentAmount: payload.installmentAmount,
                p_startPeriodId: payload.startPeriodId,
                p_balanceAmount: payload.balanceAmount,
                p_status: payload.status,
                p_loanCreatedBy: payload.createdBy ?? "SYSTEM",
                p_loanIsActive: payload.isActive ? 1 : 0,
                p_loanRemarks: payload.remarks ?? "",
            }
        }
    )
}

const UpdateLoan = (payload) => {
    return axios.post(
        "Loan/UpdateLoan",
        null,
        {
            params: {
                p_loanId: payload.loanId,
                p_employeeId: payload.employeeId,
                p_loanNo: payload.loanNo,
                p_loanType: payload.loanType,
                p_loanDescription: payload.loanDescription,
                p_loanDate: payload.loanDate,
                p_approvedDate: payload.approvedDate || null,
                p_approvedBy: payload.approvedBy || "",
                p_loanAmount: payload.loanAmount,
                p_interestRate: payload.interestRate,
                p_totalInterest: payload.totalInterest,
                p_totalAmount: payload.totalAmount,
                p_noOfInstallments: payload.noOfInstallments,
                p_installmentAmount: payload.installmentAmount,
                p_startPeriodId: payload.startPeriodId,
                p_balanceAmount: payload.balanceAmount,
                p_status: payload.status,
                p_loanCreatedBy: payload.createdBy ?? "SYSTEM",
                p_loanIsActive: payload.isActive ? 1 : 0,
                p_loanRemarks: payload.remarks ?? "",
            }
        }
    )
}

const GetLoansByEmployee = async (employeeId) => {
    return axios.get(
        "Loan/GetLoansByEMPId",
        {
            params: {
                p_employeeId: employeeId,
            }
        }
    )
}

const GetLoanInstallments = async (loanId) => {
    return axios.get(
        "Loan/GetInstallmentsByLoan",
        {
            params: {
                p_loanId: loanId,
            }
        }
    )
}

const AddLoanInstallment = async (payload) => {
    return axios.post(
        "Loan/AddInstallment",
        payload
    );
};

// ---- Overtime (OT) ----
const GetOvertimeList = () => {
    return axios
        .get("OT/GetOvertime")
        .then((response) => response);
};

const GetOvertimeById = (overtimeId) => {
    return axios.get(
        "OT/GetOvertimeById",
        {
            params: {
                p_overtimeId: overtimeId,
            }
        }
    );
};

const GetOvertimeByEmployee = (employeeId) => {
    return axios.get(
        "OT/GetOvertimeByEmployee",
        {
            params: {
                p_employeeId: employeeId,
            }
        }
    );
};

const AddOvertime = (payload) => {
    return axios.post(
        "OT/AddOvertime",
        null,
        {
            params: {
                p_employeeId: payload.employeeId,
                p_payrollPeriodId: payload.payrollPeriodId,
                p_otDate: payload.otDate,
                p_otType: payload.otType,
                p_startTime: payload.startTime,
                p_endTime: payload.endTime,
                p_totalHours: payload.totalHours,
                p_otRate: payload.otRate,
                p_otAmount: payload.otAmount,
                p_isApproved: payload.isApproved ? 1 : 0,
                p_approvedBy: payload.approvedBy || "",
                p_createdBy: payload.createdBy ?? "SYSTEM",
                p_isActive: payload.isActive ? 1 : 0,
            }
        }
    );
};

const UpdateOvertime = (payload) => {
    return axios.post(
        "OT/UpdateOvertime",
        null,
        {
            params: {
                p_overtimeId: payload.overtimeId,
                p_employeeId: payload.employeeId,
                p_payrollPeriodId: payload.payrollPeriodId,
                p_otDate: payload.otDate,
                p_otType: payload.otType,
                p_startTime: payload.startTime,
                p_endTime: payload.endTime,
                p_totalHours: payload.totalHours,
                p_otRate: payload.otRate,
                p_otAmount: payload.otAmount,
                p_isApproved: payload.isApproved ? 1 : 0,
                p_approvedBy: payload.approvedBy || "",
                p_payrollId: payload.payrollId,
                p_createdBy: payload.createdBy ?? "SYSTEM",
                p_isActive: payload.isActive ? 1 : 0,
            }
        }
    );
};


// ─── LEAVE REQUESTS ──────────────────────────────────────────────────────

const GetLeavesRequestByStatus = async (status) => {
    return axios.get("Leave/GetLeavesByStatus", {
        params: {
            p_status: status,
        }
    }).then((response) => response)
        .catch((error) => {
            console.error('[GetLeavesRequestByStatus] Error:', error);
            throw error;
        });
};

const GetPendingLeave = async () => {
    return axios.get("Leave/GetPendingLeaves")
        .then((response) => response)
        .catch((error) => {
            console.error('[GetPendingLeave] Error:', error);
            throw error;
        });
};

const GetApprovedLeave = async () => {
    return axios.get("Leave/GetApprovedLeaves")
        .then((response) => response)
        .catch((error) => {
            console.error('[GetApprovedLeave] Error:', error);
            throw error;
        });
};

const GetRejectedLeave = async () => {
    return axios.get("Leave/GetRejectedLeaves")
        .then((response) => response)
        .catch((error) => {
            console.error('[GetRejectedLeave] Error:', error);
            throw error;
        });
};

const GetCanceledLeave = async () => {
    return axios.get("Leave/GetCanceledLeaves")
        .then((response) => response)
        .catch((error) => {
            console.error('[GetCanceledLeave] Error:', error);
            throw error;
        });
};

const ApproveLeave = async (formId, formNo, approvedBy, remarks) => {
    return axios.post("Leave/ApproveLeave", null, {
        params: {
            p_form_id: formId,
            p_form_no: formNo,
            p_approved_by: approvedBy,
            p_remarks: remarks || '',
        }
    }).then((response) => response)
        .catch((error) => {
            console.error('[ApproveLeave] Error:', error);
            throw error;
        });
};

const RejectLeave = async (formId, formNo, rejectedBy, remarks) => {
    return axios.post("Leave/RejectLeave", null, {
        params: {
            p_form_id: formId,
            p_form_no: formNo,
            p_rejected_by: rejectedBy,
            p_remarks: remarks || '',
        }
    }).then((response) => response)
        .catch((error) => {
            console.error('[RejectLeave] Error:', error);
            throw error;
        });
};

const GetLeaveTypeList = async () => {
    return axios.get("Leave/GetLeaveTypes")
        .then((response) => response)
        .catch((error) => {
            console.error('[GetLeaveTypeList] Error:', error);
            throw error;
        });
};

// ------------ PAYROLL CALCULATION -------------

const GetPreviewPayroll = async (payrollPeriodId, employeeId) => {
    return axios.get("Preview/GetPreviewPayroll", {
        params: {
            P_PAYROLL_PERIOD_ID: payrollPeriodId,
            P_EMPLOYEE_ID: employeeId,
        }
    });
};

const CalculatePayroll = async (payrollPeriodId, createdBy = "system") => {
    return axios.post(
        "PayrollCal/CalPayRoll",
        null,
        {
            params: {
                P_PAYROLL_PERIOD_ID: payrollPeriodId,
                P_CREATED_BY: getLoggedInServiceNo() || createdBy || 'admin',
            },
        }
    );
};

const GetPayrollDetailsBySno = async (payrollPeriodId, serviceNo) => {
    return axios.get("PayRollCal/GetPayrollDetailsBySno", {
        params: {
            P_PAYROLL_PERIOD_ID: payrollPeriodId,
            P_SERVICE_NO: serviceNo,
        }
    });
};

const ReversePayroll = async (payrollPeriodId) => {
    return axios.post(
        "PayRollCal/RevPayRoll",
        null,
        {
            params: {
                P_PAYROLL_PERIOD_ID: payrollPeriodId,
            }
        }
    )
}


// ------------ BANK REPORT / PAYROLL TEXT FILE ------------

const GetPayRollPeriod = async () => {
    try {
        const response = await api.get("/PayRoll/GetPayRollPeriod");
        return response;
    } catch (error) {
        console.error("Error fetching payroll periods:", error);
        throw error;
    }
};

/**
 * Get the current month's payroll period ID
 */
const GetCurrentPeriodId = async () => {
    try {
        const response = await GetPayRollPeriod();
        const resultSet = response?.ResultSet || [];
        
        if (!Array.isArray(resultSet) || resultSet.length === 0) {
            throw new Error('No payroll periods found.');
        }

        // Get current month and year
        const now = new Date();
        const currentMonth = String(now.getMonth() + 1);
        const currentYear = String(now.getFullYear());

        console.log('[PayrollService] Looking for period:', {
            currentMonth,
            currentYear,
            availablePeriods: resultSet.map(p => ({
                id: p.HPP_PAYROLL_PERIOD_ID,
                month: p.HPP_MONTH,
                year: p.HPP_YEAR,
                name: p.HPP_PERIOD_NAME
            }))
        });

        // Find period matching current month and year
        const currentPeriod = resultSet.find(period => {
            const periodMonth = String(period.HPP_MONTH || '');
            const periodYear = String(period.HPP_YEAR || '');
            return periodMonth === currentMonth && periodYear === currentYear;
        });

        if (!currentPeriod) {
            console.log('[PayrollService] No exact match found, using most recent period');
            const sorted = [...resultSet].sort((a, b) => 
                parseInt(b.HPP_PAYROLL_PERIOD_ID) - parseInt(a.HPP_PAYROLL_PERIOD_ID)
            );
            return sorted[0]?.HPP_PAYROLL_PERIOD_ID || null;
        }

        console.log('[PayrollService] Found current period:', {
            id: currentPeriod.HPP_PAYROLL_PERIOD_ID,
            name: currentPeriod.HPP_PERIOD_NAME,
            month: currentPeriod.HPP_MONTH,
            year: currentPeriod.HPP_YEAR
        }); 

        return currentPeriod.HPP_PAYROLL_PERIOD_ID;
    } catch (error) {
        console.error("Error getting current period ID:", error);
        throw error;
    }
};

const GetBankReportDetailsByPeriodId = async (periodId) => {
    try {
        
        const response = await api.get(`/BankReport/GetdetailsByPeriodId?periodID=${periodId}`);
        console.log('[PayrollService] Response status:', response?.StatusCode);
        return response;
    } catch (error) {
        console.error("Error fetching bank report details by period:", error);
        throw error;
    }
};

const GetSalaryComponentSummary = async (periodId, gradeCode = '') => {
    try {
        let url = `/BankReport/GetSalaryComponentSummsery?periodID=${periodId}`

        if (gradeCode) {
            url += `&p_GradeCode=${gradeCode}`
        }

        const response = await api.get(url);
        return response;
    } catch (error) {
        console.error("Error fetching salary component summary:", error);
        throw error;
    }
}



const AddBankReport = async (data) => {
    console.log('[AddBankReport] Input data:', data);

    const params = {
        p_Tran_ID: data.p_Tran_ID || 0,
        p_Bank_Name: data.p_Bank_Name || '',
        p_Destination_Bank: data.p_Destination_Bank || '',
        p_Branch_Name: data.p_Branch_Name || '',
        p_Destination_Br: data.p_Destination_Br || '',
        p_Branch_Swift_Code: data.p_Branch_Swift_Code || '',
        p_Destination_Account: data.p_Destination_Account || '',
        p_Destination_Account_Name: data.p_Destination_Account_Name || '',
        p_TRN_Code: data.p_TRN_Code || 0,
        p_Return_Code: data.p_Return_Code || 0,
        p_Cr_Dr_Code: data.p_Cr_Dr_Code || 0,
        p_Amount: data.p_Amount || 0,
        p_Amount_Decimal: data.p_Amount_Decimal || 0,
        p_Particulars: data.p_Particulars || '',
        p_Reference: data.p_Reference || '',
        p_Value_Date: data.p_Value_Date || 0,
        p_Security_Field: data.p_Security_Field || 0,
        p_Filler: data.p_Filler || '@',
        p_NIC_Number: data.p_NIC_Number || '',
        p_Created_By: data.p_Created_By || 'admin',
        p_Originating_BankCode: data.p_Originating_BankCode || '',
        p_Originating_BranchCode: data.p_Originating_BranchCode || '',
    };

    console.log('[AddBankReport] Final params:', params);

    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            searchParams.append(key, params[key]);
        }
    });

    const url = `/BankReport/AddBankReport?${searchParams.toString()}`;
    console.log('[AddBankReport] URL:', url);

    return axios.post(url, null, {
        headers: {
            'Content-Type': 'application/json',
        }
    }).then((response) => {
        console.log('[AddBankReport] Response:', response);
        return response;
    }).catch((error) => {
        console.error('[AddBankReport] Error:', error);
        throw error;
    });
};

// const GetBankReportDetailsByDate = async (createdDate) => {
//     return axios.get("BankReport/GetBankReportdetails", {
//         params: {
//             p_Created_Date: createdDate,
//         }
//     });
// };

const GetBankReportDetailsByDate = async (createdDate, gradeCode) => {
    const [year, month] = createdDate.split("-");

    const params = {
        p_year: year,
        p_month: month,
    }

    if (gradeCode) {
        params.p_GradeCode = gradeCode;
    }

    return axios.get("BankReport/GetBankReportdetails", {
        params
    });
};

// ------------ BANK REPORT VALIDATION (Prepared / Authorized / Approved) ------------

const MarkBankReportPrepared = async (year, month) => {
    try {
        const response = await api.get(
            `/BankReport/BankReportPreparedBy?p_year=${year}&p_month=${month}`
        );
        return response;
    } catch (error) {
        console.error("Error marking bank report as prepared:", error);
        throw error;
    }
};

const MarkBankReportAuthorized = async (year, month) => {
    try {
        const response = await api.get(
            `/BankReport/BankReportAuthorizedBy?p_year=${year}&p_month=${month}`
        );
        return response;
    } catch (error) {
        console.error("Error marking bank report as authorized:", error);
        throw error;
    }
};

const MarkBankReportApproved = async (year, month) => {
    try {
        const response = await api.get(
            `/BankReport/BankReportApprovedBy?p_year=${year}&p_month=${month}`
        );
        return response;
    } catch (error) {
        console.error("Error marking bank report as approved:", error);
        throw error;
    }
};

const payRollService = {
    GetPayRollPeriodList,
    AddPayRollPeriod,
    UpdatePayRollPeriod,

    GetPayRollComponentList,
    AddPayRollComponent,
    UpdatePayRollComponent,

    GetPayRollBatchList,
    AddPayRollBatch,
    UpdatePayRollBatch,

    GetPayRollHeaderList,
    getPayrollHeadersByPeriod,

    BatchEmployee: PayrollBatchEmployeeService,

    GetEmployeeSalaryList,
    AddEmployeeSalary,
    UpdateEmployeeSalary,

    GetEmployeeSalaryComponentList,
    AddEmployeeSalaryComponent,
    UpdateEmployeeSalaryComponent,

    GetLoanList,
    AddLoan,
    UpdateLoan,

    GetLoansByEmployee,
    GetLoanInstallments,
    AddLoanInstallment,

    GetOvertimeList,
    GetOvertimeById,
    GetOvertimeByEmployee,
    AddOvertime,
    UpdateOvertime,

    GetLeavesRequestByStatus,
    GetPendingLeave,
    GetApprovedLeave,
    GetRejectedLeave,
    GetCanceledLeave,
    ApproveLeave,
    RejectLeave,
    GetLeaveTypeList,

    GetPreviewPayroll,
    CalculatePayroll,
    GetPayrollDetailsBySno,
    ReversePayroll,

    GetPayRollPeriod,
    GetCurrentPeriodId,
    GetBankReportDetailsByPeriodId,
    AddBankReport,
    GetBankReportDetailsByDate,
    GetSalaryComponentSummary,

    MarkBankReportPrepared,
    MarkBankReportAuthorized,
    MarkBankReportApproved
}

export default payRollService;